(function () {
  /**
   * @ngdoc module
   * @name binky.core.contact
   * @description Module which defines contact-related models
   */
  angular.module('binky.core.contact', ['binky.core.api.utils', 'binky.core.lodash']);
})();
